import * as React from 'react';

import {CustomizeFields} from 'shells/customize-fields/customize-fields';
import {mapFieldsToSelectableFields} from 'shells/customize-fields/helpers';
import type {EntityFormType, SelectableField} from 'shells/customize-fields/types';

import {useGetSchemaFieldsForEntityType} from '../../entity-form/forms/helpers';

import {useGetLeadCardFields, useUpdateLeadCardFields} from './graphql/hooks';

type Props = {
    onClose: () => void;
    entityType: EntityFormType;
    stagesetId: string;
    limit: number;
};

export function CustomizeFieldsWrapper(props: Props) {
    const [isSaving, setIsSaving] = React.useState<boolean>(false);
    const {leadCardFields, refetchFields} = useGetLeadCardFields(props.stagesetId);
    const saveFields = useUpdateLeadCardFields();
    const schemaFields = useGetSchemaFieldsForEntityType('leads');

    const fieldsToDisplay = leadCardFields.filter((field) => field.isBoardable);
    const nutshellFields =
        schemaFields && schemaFields.filter((field) => !field.isCustomField && field.isBoardable);
    const customFields =
        schemaFields && schemaFields.filter((field) => field.isCustomField && field.isBoardable);

    const handleSaveFields = (selectedFields: SelectableField[]) => {
        setIsSaving(true);
        saveFields({
            stagesetId: props.stagesetId,
            fields: selectedFields.map((field) => ({
                fieldId: field.fieldId,
                isRequired: field.isRequired,
            })),
        }).then(refetchFields);

        setTimeout(() => {
            setIsSaving(false);
            props.onClose();
        }, 1000);
    };

    return (
        <CustomizeFields
            selectedFields={mapFieldsToSelectableFields(fieldsToDisplay)}
            // @ts-expect-error
            refetchFields={refetchFields}
            schemaFields={schemaFields}
            handleSaveFields={handleSaveFields}
            isSaving={isSaving}
            nutshellFields={nutshellFields}
            customFields={customFields}
            entityType={props.entityType}
            onClose={props.onClose}
            limit={props.limit}
            canRequireFields={false}
            isLeadCard={true}
        />
    );
}
